import React from 'react';
import Plot from 'react-plotly.js';

const FunnelPlot = ({ sensitivity, specificity, prevalence, finalTP }) => {
  // Calculations based on props
  const sampleSizeStep1 = Math.ceil(finalTP / (sensitivity * prevalence));
  const sampleSizeStep2 = Math.ceil((sensitivity * prevalence + (1 - specificity) * (1 - prevalence)) * sampleSizeStep1);
  const screeningSize = Math.ceil(finalTP / prevalence);

  // Prepare data for both funnel plots
  const stages = ["Pre-screening", "Screening", "Final Sample"];
  const sizes = [sampleSizeStep1, sampleSizeStep2, finalTP];

  const newStages = ["Screening", "Final Sample"];
  const newSizes = [screeningSize, finalTP];

  const sumSizes = screeningSize + sampleSizeStep1;

  // Data for Plotly - we're creating two traces for the subplot
  const trace1 = {
    type: 'funnel',
    name: 'Only Screening',
    orientation: 'h',
    y: newStages,
    x: newSizes,
    marker: {color: '#C9AB77'},
    textinfo: "value+percent initial",
    xaxis: 'x'
  };

  const trace2 = {
    type: 'funnel',
    name: 'Pre-screening',
    orientation: 'h',
    y: stages,
    x: sizes,
    marker: {color: '#B6BEC1'},
    textinfo: "value+percent initial",
    xaxis: 'x2', 
    yaxis: 'y',
  };

  return (
    <Plot
      data={[trace2, trace1]}
      layout={{
        margin: { l: 100, r: 0, b: 0, t: 0, pad: 0 },
        grid: {rows: 1, columns: 2, xgap:0, subplots:[['xy', 'x2y']]},
        xaxis: {domain: [0, screeningSize / sumSizes]},
        xaxis2: {domain: [screeningSize / sumSizes, 1]},
        legend: {orientation: 'h', x: 0.5, xanchor: 'center', traceorder: 'reversed'},
        autosize: true,
        height: 400
      }}
      useResizeHandler={true}
      style={{ width: "100%" }}
    />
  );
};

export default FunnelPlot;